import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestMapComponent } from './test-map.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { TestMapRoutingModule } from './test-map-routing.module';
import { MaterialModule } from 'src/app/shared/material/material.module';

@NgModule({
  declarations: [TestMapComponent],
  imports: [CommonModule, MaterialModule, TestMapRoutingModule, MatProgressBarModule],
  exports: [TestMapComponent],
})
export class TestMapModule {}
